import { App } from 'vue';

declare const STAGE: string;

export default {
	install: (app: App<Element>): void => {
		const rollbarConfig = {
			accessToken: '63ffddb0d9ea474b9434dd7ac74fc8c8',
			captureUncaught: false,
			captureUnhandledRejections: false,
			checkIgnore: window["rollbarIgnore"],
			payload: {
				environment: STAGE,
			},
		};

		const rollbar = (window && window["rollbar"] && window["rollbarIgnore"]) ? new window["rollbar"](rollbarConfig) : null;

		app.config.errorHandler = (error: any): void => {
			if (rollbar === null) {
				return;
			}

			if (STAGE === 'prd') {
				rollbar.error(error);
			}

			throw error;
		};
	},
};
